// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"180":"0dd07913","206":"aa293bdd","389":"418bf070","631":"19cac048","825":"34f93904"}[chunkId] + ".js";
};